export var headers = {
	"Project-Id-Version": "open-xchange-appsuite-iol-smb",
	"Report-Msgid-Bugs-To": "",
	"POT-Creation-Date": "",
	"PO-Revision-Date": "2020-09-15 14:00+0100",
	"Last-Translator": "Youssef Benabdalla <youssef.benabdalla@open-xchange.com>",
	Language: "",
	"Language-Team": "en_US",
	"Content-Type": "text/plain; charset=UTF-8",
	"Content-Transfer-Encoding": "8bit",
	"Plural-Forms": "nplurals=2; plural=n > 1;",
	"MIME-Version": "1.0",
	"X-Generator": "Lokalize 1.5"
};
export default {
	headers: headers
};
